/* mirelia — gaveta do carrinho (secao cl-cart-drawer, replica da gaveta do Shrine 1.7 do concorrente).
   Abre: icone do carrinho / links para /cart / depois de qualquer "In den Warenkorb".
   Conteudo: re-renderizado pela Section Rendering API (?sections=cl-cart-drawer,cart-icon-bubble). */
(function () {
  if (window.__clCart) return;
  window.__clCart = true;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var OPENERS = '#cart-icon-bubble, a[href="/cart"], a[href$="/cart"], .mmk__korb, [data-cl-cart-open]';

  function box() { return document.getElementById('ClCart'); }
  function drawer() { var b = box(); return b && b.querySelector('cl-cart-drawer'); }

  function open() {
    var b = box(), d = drawer();
    if (!b || !d) { window.location.href = ROOT + 'cart'; return; }
    b.classList.add('is-open');
    document.documentElement.classList.add('cl-cart-lock');
    d.classList.add('animate');
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('active'); }); });
    var inner = d.querySelector('.drawer__inner');
    if (inner) setTimeout(function () { try { inner.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }

  function close() {
    var b = box(), d = drawer();
    if (!d) return;
    d.classList.remove('active');
    document.documentElement.classList.remove('cl-cart-lock');
    setTimeout(function () { if (!d.classList.contains('active')) b.classList.remove('is-open'); }, 320);
  }

  function json(r) {
    return r.json().catch(function () { return {}; }).then(function (d) { if (!r.ok) throw d; return d; });
  }

  function refresh() {
    return fetch(ROOT + '?sections=cl-cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(json)
      .then(function (s) {
        var d = drawer();
        if (s['cl-cart-drawer'] && d) {
          var tmp = document.createElement('div');
          tmp.innerHTML = s['cl-cart-drawer'];
          var nd = tmp.querySelector('cl-cart-drawer');
          if (nd) {
            var ni = nd.querySelector('.drawer__inner'), oi = d.querySelector('.drawer__inner');
            if (ni && oi) oi.innerHTML = ni.innerHTML;
            d.classList.toggle('is-empty', nd.classList.contains('is-empty'));
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (s['cart-icon-bubble'] && bubble) {
          var t2 = document.createElement('div');
          t2.innerHTML = s['cart-icon-bubble'];
          var nb = t2.querySelector('#cart-icon-bubble') || t2.firstElementChild;
          if (nb) bubble.innerHTML = nb.innerHTML;
        }
      });
  }

  function loading(on) { var b = box(); if (b) b.classList.toggle('is-loading', !!on); }

  function change(line, qty) {
    loading(true);
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(json).then(refresh).catch(function () {}).then(function () { loading(false); });
  }

  function formOf(btn) {
    var id = btn.getAttribute('form');
    return (id && document.getElementById(id)) || btn.closest('form');
  }

  function showError(form, msg) {
    var scope = form.closest('product-form, product-info, section, .shopify-section') || document;
    var box_ = scope.querySelector('.product-form__error-message'), wrap = scope.querySelector('.product-form__error-message-wrapper');
    if (box_) { box_.textContent = msg; if (wrap) wrap.hidden = false; }
    else window.alert(msg);
  }

  function add(form, btn) {
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('loading'); }
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(json)
      .then(function () { return refresh().catch(function () {}); })
      .then(open)
      .catch(function (d) {
        showError(form, (d && (d.description || d.message)) || 'Der Artikel konnte nicht hinzugefügt werden.');
      })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('loading'); } });
  }

  function isCartAdd(form) {
    return form && /\/cart\/add/.test(form.getAttribute('action') || '');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = box();
    if (t.closest('[data-cl-cart-close]') && b && b.contains(t)) {
      if (t.closest('a[href]')) { close(); return; }
      e.preventDefault(); close(); return;
    }
    var qb = t.closest('[data-cl-cart-qty]');
    if (qb && b && b.contains(qb)) {
      e.preventDefault();
      var li = qb.closest('[data-index]');
      if (li) change(+li.getAttribute('data-index'), +qb.getAttribute('data-cl-cart-qty'));
      return;
    }
    var atc = t.closest('button[name="add"], button[type="submit"][data-cl-atc]');
    if (atc && !(b && b.contains(atc))) {
      var f = formOf(atc);
      if (isCartAdd(f)) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (!atc.hasAttribute('aria-busy')) add(f, atc);
        return;
      }
    }
    var op = t.closest(OPENERS);
    if (op && !(b && b.contains(op))) {
      e.preventDefault(); e.stopPropagation();
      open(); refresh().catch(function () {});
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || !isCartAdd(f)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    add(f, f.querySelector('[name="add"]'));
  }, true);

  document.addEventListener('change', function (e) {
    var i = e.target;
    var b = box();
    if (!i || !b || !b.contains(i) || !i.classList.contains('quantity__input')) return;
    var li = i.closest('[data-index]');
    if (li) change(+li.getAttribute('data-index'), parseInt(i.value, 10) || 0);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.clCartOpen = open;
  window.clCartRefresh = refresh;
})();
